export default "__VITE_ASSET__DEnAdVRr__"